module.exports = __webpack_public_path__ + "static/media/background_studio2.4d24e122.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/background_studio2.jpg
// module id = 624
// module chunks = 0